import { GridList } from '@sleepstation/components'
import { LAYOUT_SPACING } from '@sleepstation/const'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { HUB_CARD_VARIANT } from '../../../../../../const/variants'
import DualColumnCtaCard from '../cards/DualColumnCtaCard'
import ImageCtaCard from '../cards/ImageCtaCard'
import InfoImageCard from '../cards/InfoImageCard'
import LinkCard from '../cards/LinkCard'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const VARIANT = {
  [HUB_CARD_VARIANT.IMAGE_CTA]: ImageCtaCard,
  [HUB_CARD_VARIANT.INFO_IMAGE]: InfoImageCard,
  [HUB_CARD_VARIANT.DUAL_COLUMN_CTA]: DualColumnCtaCard,
  [HUB_CARD_VARIANT.LINK]: LinkCard,
}

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const getCardVariant = (variant) => {
  const Card = VARIANT[variant]
  if (!Card) {
    throw new Error(
      `[HubItemsList] No component available for variant: '${variant}'`
    )
  }
  return Card
}

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(GridList).attrs(({ columns }) => ({
  spacing: LAYOUT_SPACING.LARGE,
  columns,
  'data-cy': `hub-items-list`,
}))``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HubItemsList = ({ items, columns }) => (
  <Layout columns={columns}>
    {renderList(({ variant, ...props }) => {
      const Card = getCardVariant(variant)
      return <Card {...props} />
    }, items)}
  </Layout>
)

HubItemsList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.number).isRequired,
}

export default HubItemsList
